import './style.css';
import { mountApp } from './ui/app.js';
import { readFrameEnv, isFramingAllowed, describeEmbedder } from './util/frame-guard.js';

// Anti-clickjacking: run framed only under an allowlisted embedder (Puter's own
// GUI, which launches installed apps in an iframe). See util/frame-guard.js.
const frameEnv = readFrameEnv(window);
if (!isFramingAllowed(frameEnv)) {
  document.documentElement.textContent =
    `Vault cannot be opened inside a frame (embedder: ${describeEmbedder(frameEnv)}).`;
  throw new Error('refusing to run framed');
}

mountApp(document.getElementById('app'));

// Register the offline app-shell service worker. Non-fatal on failure, and a
// no-op on browsers without SW support or insecure contexts (file://). The
// `/sw.js` path (scope `/`) assumes root hosting (Puter subdomain root); unlike
// the index.html asset links, Vite does not rewrite this runtime string, so a
// subpath deployment would 404 here and silently disable the PWA.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}
